import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import de from './locales/de.json';

i18n
  .use(initReactI18next) // Bind react-i18next to React
  .use(LanguageDetector) // Detect user language
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de }
    },
    // lng: "de", // Force language to German
    fallbackLng: "en", // Default language
    interpolation: { escapeValue: false }
  });

export default i18n;
